import React from "react";
import { Modal, ModalHeader, ModalFooter } from "reactstrap";
import SpinnerButton from "../Button";

function ValidateModalMessage({ toggle, isAfter, handleOkClick }) {
  let msg = "";
  if (isAfter) {
    msg = "Esta Alerta creó su tarea en Calendar el mes corriente para su gestión";
  } else {
    msg = "Esta Alerta no impacta en Calendar el mes corriente";
  }

  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <ModalHeader className="text-center" toggle={toggle}>
        {msg}
      </ModalHeader>
      <ModalFooter>
        <div className="mb-0 px-3 w-100 d-flex align-items-center justify-content-center">
          <SpinnerButton className="btn btn-primary center" type="button" onClick={handleOkClick}>
            OK
          </SpinnerButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ValidateModalMessage;
